<template>
  <v-container>
    <v-window v-model="step">
      <v-window-item>
        <div class="text-h4">
          Michigan Intrastate Switched Toll Access Restructuring Mechanism Exemption Certificate
        </div>
        <v-text-field
          v-model="general.stateaccesstax_company_name"
          label="Company Name"
        ></v-text-field>
        <v-text-field
          v-model="general.stateaccesstax_accounts_exempt"
          label="Exempt Accounts"
        ></v-text-field>
        <v-text-field
          v-model="general.stateaccesstax_registration_number"
          label="State Registration Number"
        ></v-text-field>
        <AddressAutocomplete
          :value="stateaccesstaxAddress"
          @registerAddressChange="setAddress"
        />
      </v-window-item>
      <v-window-item>
        <div class="text-h4">Authorized Contact & Signature</div>
        <ESignature
          v-model="general.stateaccesstax_sig_name"
          :accepted.sync="general.stateaccesstax_certified"
          :preamble="signaturePreamble"
        >
          <Contact
            :d="contactData"
            :roles="['Access Charges Exemption Contact']"
            @assignContact="assignContact"
            contact-title
          />
        </ESignature>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddressAutocomplete from "@/components/formfields/AddressAutocomplete.vue";
import ESignature from "@/components/formfields/ESignature.vue";
import Contact from '@/components/formfields/Contact.vue';
import _ from 'lodash';

export default {
  name: "MIAccessCharges",
  data() {
    return {
      step: 0,
      general: {},
    };
  },
  methods: {
    ...mapActions(['syncFormData', 'nextSubTab', 'hijackStepper', 'unHijackStepper']),
    sync() {
      const vm = this;
      vm.syncFormData({
        mainKey: 'general',
        data: _.cloneDeep(vm.general),
      });
    },
    setAddress(newAddress) {
      this.$set(this.general, 'stateaccesstax_address', newAddress.streetAddress);
      this.$set(this.general, 'stateaccesstax_suite', newAddress.suite);
      this.$set(this.general, 'stateaccesstax_city', newAddress.city);
      this.$set(this.general, 'stateaccesstax_state', newAddress.state);
      this.$set(this.general, 'stateaccesstax_zip', newAddress.zip);
    },
    assignContact(e) {
      this.$set(this.general, 'stateaccesstax_contact_name', e.fullname);
      this.$set(this.general, 'stateaccesstax_email', e.email);
      this.$set(this.general, 'stateaccesstax_contact_phone', e.phone);
      this.$set(this.general, 'stateaccesstax_title', e.title);
    },
  },
  computed: {
    ...mapGetters(['getQuoteInfo', 'getQuoteFacts']),
    stateaccesstaxAddress() {
      const address = {};
      if (this.general.stateaccesstax_address != null) {
        address.streetAddress = this.general.stateaccesstax_address;
        address.suite = this.general.stateaccesstax_suite;
        address.city = this.general.stateaccesstax_city;
        address.state = this.general.stateaccesstax_state;
        address.zip = this.general.stateaccesstax_zip;
      }
      return address;
    },
    maxStep() {
      return 1;
    },
    signaturePreamble() {
      return `
The undersigned represents he/she is authorized to execute this certificate on behalf of <b>${this.general.stateaccesstax_company_name}</b>.("Company") and hereby claims exemption from 123.Net,Inc.'s assessment of a Michigan Intrastate Switched Toll Access Restructuring Mechanism("ARM") surcharge on Company's purchases from 123.Net, Inc. 24700 Northwestern Hwy. Fl.7 Southfield, MI 48075 ("123.Net").

I certify that the Company is purchasing telecommunications and/or Voice over Internet Protocol ("VoIP") services for resale to end-users in Michigan and accepts responsibility for remitting Michigan Intrastate Switched Toll Access Restructuring Mechanism Surcharges on these services, where applicable, directly to the State.

I further certify that if any telecommunications and/or VoIP service so purchased with this exemption is used or consumed by Company as to make it subject to ARM, Company will pay the ARM directly to the proper taxing authority when state law so provides, or will inform 123.NET so that the ARM charge may be added to the Company's 123.Net billing. This certificate will be considered a part of each order which Company may hereafter give to and shall be valid until cancelled by Company in writing or revoked by the State.

I declare under the penalties of perjury that this certificate has been examined by me and to the best of my knowledge and belief all statements contained herein are true, correct and accurate.
      `;
    },
    contactData() {
      return {
        fullname: this.general.stateaccesstax_contact_name,
      };
    },
  },
  mounted() {},
  created() {
    const vm = this;
    vm.general = _.cloneDeep(vm.getQuoteInfo);
    if (!vm.general.stateaccesstax_company_name) {
      vm.general.stateaccesstax_company_name = vm.getQuoteFacts.company_name;
    }
    vm.hijackStepper(async (goRight) => {
      if ((vm.step === 0 && !goRight) || (vm.step === vm.maxStep && goRight)) {
        vm.unHijackStepper();
        vm.nextSubTab(goRight);
      }
      vm.step += (goRight ? 1 : -1);
    });
  },
  watch: {
    general: {
      handler() {
        this.sync();
      },
      deep: true,
    },
  },
  components: {
    AddressAutocomplete,
    ESignature,
    Contact,
  },
};
</script>

<style lang="scss" scoped>
</style>
